export interface GetAntrepoOutListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetAntrepoOutListPagingAndFilterResponseData
}

export interface GetAntrepoOutListPagingAndFilterResponseData {
    items: GetAntrepoOutListPagingAndFilterResponseItem[]
    totalRecordCount: number
    totals: GetAntrepoOutListPagingAndFilterResponseTotals | undefined
}

/** Görüntülenen sayfadaki kayıtların dip toplamı. */
export interface GetAntrepoOutListPagingAndFilterResponseTotals {
    declarationPotQuantity: number
    declarationPotWeight: number
    totalPotQuantity: number
    totalGrossWeight: number
    waitingTotalPotQuantity: number
    waitingTotalGrossWeight: number
    stockTotalPotQuantity: number
    stockTotalGrossWeight: number
    rowCount: number
}

export interface GetAntrepoOutListPagingAndFilterResponseItem {
    antrepoOutId: string
    antrepoInId: string
    companyId: string
    antrepoDeclarationNo: string
    antrepoExitDate: string
    receiptNo: any
    antrepoDeclarationDate: string
    goodsAmount: number
    goodsAmountCurrencyTypeId: string
    receiptDate: any
    senderFirmId: string
    guaranteeAmount: number
    guaranteeAmountCurrencyTypeId: string
    ledgerNo: string
    goodsAmountCurrencyTypeName: string
    senderFirmName: string
    guaranteeAmountCurrencyTypeName: string
    isPartial: boolean
    exitTypeKey: string | undefined
    antrepoOutVehicles: GetAntrepoOutListPagingAndFilterResponseAntrepoOutVehicle[]
    antrepoOutVehicleProducts: GetAntrepoOutListPagingAndFilterResponseAntrepoOutVehicleProduct[]
    antrepoOutVehicleServices: GetAntrepoOutListPagingAndFilterResponseAntrepoOutVehicleService[]
    fileArchives: GetAntrepoOutListPagingAndFilterResponseFileArc[]
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
    // Araçlar alt tablosundan birleşik kolonlar (tekrarsız, ", " ile ayrılmış).
    antrepoExitDatesStr?: string
    vehiclePlates?: string
    trailerPlates?: string
    supplierNames?: string
    containerNos?: string
    transportDocumentNos?: string
    truckReportNos?: string
}

export interface GetAntrepoOutListPagingAndFilterResponseAntrepoOutVehicle {
    antrepoOutVehicleId: string
    antrepoOutId: string
    groupNo: number
    vehicleId: any
    trailerId: any
    containerNo: any
    containerId: any
    vehicleArriveDate: any
    supplierId: any
    transportDocumentNo: any
    truckReportNo: any
    welcomeId: any
    trailerName: any
    containerName: any
    supplierName: any
    vehicleName: any
}

export interface GetAntrepoOutListPagingAndFilterResponseAntrepoOutVehicleProduct {
    antrepoOutVehicleProductId: string
    antrepoOutVehicleId: string
    groupNo: number
    gTipId: string
    gTipName: string
    productTypeId: string
    potQuantity: number
    grossWeight: number
    netWeight: number
    volume: number
    area: number
    productTypeName: string
    productName: string
}

export interface GetAntrepoOutListPagingAndFilterResponseAntrepoOutVehicleService {
    antrepoOutVehicleServiceId: string
    antrepoOutVehicleId: string
    groupNo: number
    serviceId: string
    quantity: number
    multiplierId: string
    serviceName: string
    multiplierName: string
}

export interface GetAntrepoOutListPagingAndFilterResponseFileArc {
    fileArchiveId: string
    entityId: string
    fileName: string
    url: string
    fileTypeId: string
    description: string
    fileTypeName: string
    createdDate: string
}

export const initialGetAntrepoOutListPagingAndFilterResponseData: GetAntrepoOutListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0,
    totals: undefined
}